import { createSlice } from '@reduxjs/toolkit'

type Status = 'idle' | 'loading' | 'succeeded' | 'failed'

interface StreamsState {
  status: Status
  error: string | null
}

const initialState: StreamsState = {
  status: 'idle',
  error: null,
}

const streamsSlice = createSlice({
  name: 'streams',
  initialState,
  reducers: {
    clearStreams(state) {
      state.status = 'idle'
      state.error = null
    },
  },
})

export const { clearStreams } = streamsSlice.actions
export default streamsSlice.reducer
